// Auto-generated by build.js - do not edit
export const BUILD_ENV = "dev";
export const DEBUG = true;
export const GIT_REV = "unknown";
export const VERSION = "1.1.0";
